export const BEIJING_TIME_ZONE = 'Asia/Shanghai'

function asDate(value) {
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? null : date
}

export function formatBeijingTime(value, options = {}) {
  if (!value) return ''
  const date = asDate(value)
  if (!date) return ''
  return new Intl.DateTimeFormat('zh-CN', {
    timeZone: BEIJING_TIME_ZONE,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    ...options,
  }).format(date)
}

export function formatBeijingDate(value) {
  if (!value) return ''
  const date = asDate(value)
  if (!date) return ''
  return new Intl.DateTimeFormat('zh-CN', {
    timeZone: BEIJING_TIME_ZONE,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  }).format(date)
}
